<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-row class="justify-content-center">
      <b-col md="7" class="mt-3" v-if="auftrag.id !== 'testid'">
        <b-card-group>
          <b-card id="auftrag1" ref="el">
            <div slot="header"
                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
              Auftrag an: <strong>{{auftrag.a_nehmer}}</strong>
            </div>
            <b-row style="border-bottom: 1px solid #ccc!important;">
              <b-col sm="6">
                <b-form-group
                    label="Auftraggeber:"
                    label-for="auftraggeber"
                >
                  <b-form-input
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                      disabled
                      id="auftraggeber"
                      type="text"
                      :placeholder="auftrag.auftraggeber"
                      v-model="auftrag.auftraggeber"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <!--b-col sm="1" style="padding-left: 8px;">
                <account-box class="icon-2x" fillColor="#1B8EB7" :size="72" style="color: #3EA662;
    position: absolute;
    bottom: 1.20rem; cursor: pointer" @click="showAddressModal"></account-box>
              </b-col-->
              <b-col sm="6">
                <b-form-group
                    label="Zieltermin an/bis:"
                    label-for="date"
                >
                  <datetime
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                      :disabled="isEditMode"
                      v-model="auftrag.ziel_datum"
                      input-class="form-control"
                      input-style="color: black;"
                      input-id="date"
                      :aria-placeholder="formateDate"
                      :phrases="datetimeConfig.phrases"
                      :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                      :min-datetime="datetimeConfig.minTime"></datetime>

                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <b-form-group
                    label="Zahlungspflichtiger/Buchungsstelle:"
                    label-for="hh"
                >
                  <b-form-input
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                      disabled
                      id="hh"
                      type="text"
                      v-model="auftrag.gi_hh_aus"
                      :placeholder="auftrag.gi_hh_aus"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-0" style="border-bottom: 1px solid #ccc!important;">
              <b-col>
                <b-form-group
                    label="Belegnummer:"
                    label-for="bnr"
                >
                  <b-form-input
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                      disabled
                      id="bnr"
                      type="text"
                      v-model="auftrag.beleg_ex"
                      :placeholder="auftrag.beleg_ex"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col sm="2">
                <p class="p-center">Auftragstitle:</p>
              </b-col>
              <b-col>
                <b-form-input
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    class="bold-text"
                    :disabled="true"
                    type="text"
                    v-model="auftrag.gi_auf_ext"
                    :placeholder="auftrag.gi_auf_ext"
                >
                </b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="2">
                <p class="p-center">Suchbegriff:</p>
              </b-col>
              <b-col>
                <b-form-input
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    disabled
                    type="text"
                    v-model="auftrag.gi_match"
                    :placeholder="auftrag.gi_match"
                >
                </b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="2">
                <p class="p-center">Auftragsnummer:</p>
              </b-col>
              <b-col>
                <b-form-input
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    disabled
                    type="text"
                    v-model="a_nr"
                    :placeholder="a_nr"
                >
                </b-form-input>
              </b-col>
            </b-row>
            <b-row v-if="hasContact">
              <b-col sm="2">
                <p class="p-center">Für Rückfragen:</p>
              </b-col>
              <b-col>
                <b-form-textarea
                    class="text-black"
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                    disabled
                    type="text"
                    v-model="contact"
                    :placeholder="contact"
                    wrap="hard"
                    rows="3"
                    :max-rows="maxrows"
                >
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col sm="2"></b-col>
              <b-col>
                <b-form-textarea id="info-box" ref="infoBox"
                                 class="text-black"
                                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                 :placeholder="auftrag.gi_memo"
                                 :rows="4"
                                 :max-rows="maxrows"
                                 wrap="hard"
                                 :disabled="isEditMode"
                                 v-model="auftrag.gi_memo"

                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-3" style="border-top: 1px solid #ccc!important;">
              <b-col sm="2" class="mt-3">
                <p class="p-center">Versand an:</p>
              </b-col>
              <b-col class="mt-3">
                <b-form-input
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    disabled
                    type="text"
                    v-model="auftrag.email"
                    :placeholder="auftrag.email"
                >
                </b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col sm="2">
                <p class="p-center">Datum:</p>
              </b-col>
              <b-col>
                <b-form-input
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    disabled
                    type="text"
                    v-model="formateDate"
                    :placeholder="formateDate"
                >
                </b-form-input>
              </b-col>

              <b-col sm="2">
                <p class="p-center">Unterschrift:</p>
              </b-col>
              <b-col>
                <b-form-input
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    disabled
                    type="text"
                    v-model="auftrag.sachbearbeiter"
                    :placeholder="auftrag.sachbearbeiter"
                >
                </b-form-input>
              </b-col>
            </b-row>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col md="5" class="mt-3" v-if="auftrag.id !== 'testid'">
        <b-card>
          <b-row style="gap: 10px">
            <b-button  v-if="canAccept" variant="success" class="btn-pill font-lg" v-on:click="showAccept(true)">
              Einzelauftrag annehmen
            </b-button>
            <b-button  v-if="canAccept" variant="success" class="btn-pill font-lg" v-on:click="showAccept(false)">
              Aufgabe annehmen
            </b-button>
              <b-button v-if="canAccept" variant="warning" class="btn-pill font-lg" @click="showDenyAufgabe">
                Ablehnen
              </b-button>
            <!--
            // todo wiedervorlage
            -->
              <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
                Zurück
              </b-button>
          </b-row>
        </b-card>
        <b-card>
          <div slot="header">
            Anhänge
          </div>
          <b-row>
            <b-col>
              <b-list-group>
                <b-list-group-item
                    button
                    class="d-flex justify-content-between align-items-center"
                    v-for="item in attachments"
                    v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                  {{item.file_name}}
                  <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                    {{formatBytes(item.file_size)}}
                  </b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="rooms.length || canAccept">
          <div slot="header">
            Chats
          </div>
          <b-row style="gap: 10px; margin-top: -12px; margin-bottom: -12px">
            <template v-for="(room, roomId, index) in rooms">
              <task-messaging-button :is-active="room.room.is_active" :name="roomId.endsWith(':task_int') ? 'Aufgaben' : 'Auftraggeber'" :new-messages="room.room.unreadCount" @open-chat="showChat = roomId; room.room.unreadCount = 0;"/>
            </template>
            <task-messaging-button name="Weiterleitungen" :is-active="forwards.length > 0" v-if="canAccept" @open-chat="openForwards = true;"/>
          </b-row>
        </b-card>

        <b-card v-if="auftrag.lat !== 0.0 && auftrag.lon !== 0.0">
          <div slot="header">
            Position
          </div>
          <b-row style="margin-bottom: 0">
            <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container"
                   ref="map_container">
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal size="sm" v-model="showDeny" id="modal-center" centered title="Aufgabe ablehnen"
             body-class="my-body" @ok="denyAnfrage">
      <b-row style="padding: 12px;">
        <b-col>
          <form>
            <b-form-group
                label="Ablehnungsnachricht:"
            >
              <b-form-textarea
                  class="text-black"
                  rows="6"
                  max-rows="40"
                  wrap="hard"
                  v-model="denyMessage"
                  style="min-height: 150px"

              ></b-form-textarea>
            </b-form-group>
          </form>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="cancel()">
          Abbrechen
        </b-button>
        <b-button size="md" variant="danger" @click="ok()">
          Ablehnen
        </b-button>
      </template>
    </b-modal>

    <select-aufisn-dialog ref="select_aufisn" @aufisn-selected="onAufisnChanged"></select-aufisn-dialog>
    <select-legr-dialog ref="select_legr" @legr-selected="onLegrChanged"></select-legr-dialog>
    <accept-task-dialog ref="accept_dialog" :bauhof-structure="bauhofStructure" :auftrag="auftrag" :augr-name="augrName"
                        :close-automatic-presets="av_close_defaults"
                        @select-aufisn="$refs.select_aufisn.showDialog()"
                        @select-legr="$refs.select_legr.showDialog()"
                        @select-planning="(users) => {$refs.select_plannings.showDialog(users)}"
                        @change-planning="(currentPlanning) => {$refs.change_todo.showDialog(currentPlanning)}"
                        @accept-task="onAcceptTask"
    ></accept-task-dialog>
    <template v-for="(room, roomId, index) in rooms">
      <task-messaging @chat-active="activateChat" :key="roomId" :room="room.room" :is-second="index !== 0" v-if="showChat === roomId && room.room != null" :last-online="room.lastOnline" @close-chat="showChat = null" @show-group="room.showChatGroup = true" @show-invite="room.showInvite = true" @user-added="addRoomUser" @leave-room="leaveRoom"/>
      <!--task-messaging-footer :is-active="room.room.is_active" :name="roomId.endsWith(':task_int') ? 'Aufgaben Chat' : 'Auftraggeber Chat'" :is-second="index !== 0" :new-messages="room.room.unreadCount" v-if="room.room !== null && showChat !== roomId" @open-chat="showChat = roomId; room.room.unreadCount = 0;"></task-messaging-footer-->
      <task-messaging-users v-if="room.room !== null" :show-group="room.showChatGroup" :users="room.room.users" @hide-group="room.showChatGroup = false"></task-messaging-users>
      <task-messaging-invite v-if="room.room != null" :show-invite="room.showInvite" :room="room.room" @hide-invite="room.showInvite = false" @hidden="room.showInvite = false" @invite-success="(userid) => {room.room.users.push({_id: userid})}"></task-messaging-invite>
    </template>

    <task-share :show-share="showShare" :task-short="taskShort" @share-success="onShared" @forward-open-success="onOpenForwards" @hidden="showShare = false"></task-share>
    <forwards-dialog :forwards="forwards" ref="forwards_dialog" @open-chat="forwardRoom = $event"/>
    <forward-messaging :room="forwardRoom" v-if="forwardRoom != null"  @close-chat="forwardRoom = null" />
    <task-forward-messaging ref="task_forward_messaging" :forwards="forwards" v-if="openForwards" @close-chat="openForwards = false" @forward="showShare = true"/>
    <a-geber-dialog ref="a_geber_dialog" :address-data="addressData" :can-edit="canAccept" :task-id="taskId" @on-changed="onChangedAddress"/>


    <select-planning-dialog ref="select_plannings" @planning-selected="(plannings) => {$refs.accept_dialog.onNewPlanning(plannings)}"></select-planning-dialog>
    <change-todo-dialog ref="change_todo" @change-todo="(todo) => {$refs.accept_dialog.onChangeTodo(todo)}"></change-todo-dialog>

  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from 'luxon'
import {
  decryptAES,
  decryptFile,
  decryptMessages,
  encryptAES,
  encryptFile,
  encryptMultipleAES,
  encryptTodos
} from "../../../shared/crypto";
import SelectAufisnDialog from "../../aufgaben_verwaltung/SelectAufisnDialog.vue"
import SelectLegrDialog from "../../aufgaben_verwaltung/SelectLegrDialog.vue"
import AcceptTaskDialog from "../../aufgaben_verwaltung/AcceptTaskDialog.vue"
import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import TaskMessaging from "../../messaging/task_messaging.vue"
import TaskMessagingFooter from "@/views/messaging/task_messaging_footer.vue";
import TaskMessagingUsers from "@/views/messaging/task_messaging_user.vue";
import TaskMessagingInvite from "@/views/messaging/task_messaging_invite.vue";
import TaskShare from "@/views/messaging/task_messaging_share.vue";

import ForwardMessaging from "@/views/messaging/forward_messaging.vue";
import ForwardsDialog from "@/views/messaging/task_messaging_forwards_dialog.vue";
import AGeberDialog from "../../aufgaben_verwaltung/AGeberDialog.vue"
import AccountBox from 'vue-material-design-icons/AccountBox.vue';

import SelectPlanningDialog from "../../aufgaben_verwaltung/SelectPlanningDialog.vue"
import ChangeTodoDialog from "../../aufgaben_verwaltung/ChangeTodoDialog.vue"
import {v4} from "uuid";

import { doc, onSnapshot } from "firebase/firestore";
import {firestoreDb} from "@/shared/firebase";
import {listenMessageCounter, PARTICIPANT_PATH} from "@/shared/firebase/database";
import TaskMessagingButton from "@/views/messaging/task_messaging_button.vue";
import TaskForwardMessaging from "@/views/messaging/task_forward_messaging.vue";


export default {
  name: "auftrag_bauhof_offen",
  components: {
    AccountMultiplePlusIcon,
    SelectAufisnDialog,
    SelectLegrDialog,
    AcceptTaskDialog,
    TaskMessaging,
    TaskMessagingFooter,
    TaskMessagingUsers,
    TaskMessagingInvite,
    SelectPlanningDialog,
    ChangeTodoDialog,
    TaskShare,
    ForwardsDialog,
    ForwardMessaging,
    AGeberDialog,
    AccountBox,
    TaskForwardMessaging,
    TaskMessagingButton
  },
  computed: {
    isEditMode() {
      return !this.editMode;
    },
    shouldShoudFinish() {
      return this.showFinish && this.canFinish;
    },
    a_nr() {
      let base = this.auftrag.gi_augr + " / " + this.auftrag.gi_aufisn;
      if (this.auftrag.art === "DE") {
        return base;
      }
      return base + (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "" ? " (" + this.auftrag.notiz_annahme + ")" : "");
    },
    formateDate() {
      if (this.auftrag.datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    canAccept() {
      return this.auftrag.offen === 0 && this.auftrag.quittung === null;
    }
  },
  props:{
    onFileClicked: {
      type: Function,
      default: undefined
    },
    onFileOk: {
      type: Function,
      default: undefined
    },
    onAttachment: {
      type: Function,
      default: undefined
    },
    responseError: {
      type: Function,
      default: undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    showFinish: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      showChatGroup: false,
      showChat: null,
      showInvite: false,
      room: null,
      rooms: {},
      attachments: [],
      bills: [],
      auftrag: {
        id: "testid",
        a_nehmer: "Bauhof",
        auftraggeber: "Musterhausen-Public Solutions",
        ziel: "26.01.2019",
        ziel_datum: LuxonDateTime.fromJSDate(new Date()).toISO(),
        gi_hh_aus: "9300300.55511010.2-85500",
        beleg_ex: "2019-0001",
        gi_auf_ext: "Test Sven",
        gi_match: "Forstwirtschaft",
        gi_augr: "0009",
        gi_aufisn: "000038",
        gi_memo: "Test vom Sven",
        email: "info@publicsolutions.de",
        datum: "",
        sachbearbeiter: "Administrator",
        offen: 0,
        quittung: null
      },
      augrName: "",
      deleteMessage: "",
      fertigMessage: "",
      annahmeMessage: "",
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      maxrows: 40,
      editMode: false,
      textBackup: undefined,
      dateBackup: undefined,
      delete_modal: false,
      freigabe: false,
      deletable: false,
      userId: "",

      // chat specific
      hasChat: false,
      a_nehmer: "Bauhof",
      hasContact: false,
      contact: "",
      canFinish: false,
      bauhofStructure: [],

      denyMessageMmDefault: "Ihre Mängelmeldung wurde von Ihrer Kommune abgelehnt.",
      denyMessage: "",
      showDeny: false,
      listeners: {},
      lastOnline: null,
      av_close_defaults: null,
      canShare: false,
      showShare: false,
      taskShort: {
        id: "",
        title: "",
        description:"",
        where:"",
        from:"",
        till:"",
      },
      forwards: [],
      forwardRoom: null,
      openForwards: false,
      addressData: {
        gi_anrede: '',
        gi_name1: '',
        gi_name2: '',
        gi_strasse: '',
        gi_plz: '',
        gi_ort: '',

        re_anrede: '',
        renr: '',
        re_vorname: '',
        re_name1: '',
        re_str_hnr: '',
        re_land: '',
        re_plz: '',
        re_ort: '',
      },
      einzel: null,
      taskId: "",
    }
  },
  beforeDestroy: function () {
    for (const property in this.listeners) {
      this.listeners[property].forEach(listener => listener())
      this.listeners[property] = []
    }
  },
  methods: {
    activateChat(roomId) {
      this.rooms[roomId].room.is_active = true;
      if (this.listeners[roomId] === null || this.listeners[roomId] === undefined || this.listeners[roomId].length === 0) {
        this.startListener(roomId, this.userId)
      }
    },
    onChangedAddress(data) {
      this.auftrag.gi_anrede = data.a_geber_data.gi_anrede;
      this.auftrag.gi_name1 = data.a_geber_data.gi_name1;
      this.auftrag.gi_name2 = data.a_geber_data.gi_name2;
      this.auftrag.gi_strasse = data.a_geber_data.gi_strasse;
      this.auftrag.gi_plz = data.a_geber_data.gi_plz;
      this.auftrag.gi_ort = data.a_geber_data.gi_ort;

      this.auftrag.re_anrede = data.invoice_data.re_anrede;
      this.auftrag.re_nr = data.invoice_data.renr;
      this.auftrag.re_vorname = data.invoice_data.re_vorname;
      this.auftrag.re_name1 = data.invoice_data.re_name1;
      this.auftrag.re_str_hnr = data.invoice_data.re_str_hnr;
      this.auftrag.re_land = data.invoice_data.re_land;
      this.auftrag.re_plz = data.invoice_data.re_plz;
      this.auftrag.re_ort = data.invoice_data.re_ort;
    },
    showAddressModal() {
      this.taskId = this.auftrag.id;
      if (this.auftrag.gi_name1 != null) {
        this.addressData.gi_anrede = this.auftrag.gi_anrede;
        this.addressData.gi_name1 = this.auftrag.gi_name1;
        this.addressData.gi_name2 = this.auftrag.gi_name2;
        this.addressData.gi_strasse = this.auftrag.gi_strasse;
        this.addressData.gi_plz = this.auftrag.gi_plz;
        this.addressData.gi_ort = this.auftrag.gi_ort;
        if (this.auftrag.re_vorname != null) {
          this.addressData.re_anrede = this.auftrag.re_anrede;
          this.addressData.renr = this.auftrag.re_nr;
          this.addressData.re_vorname = this.auftrag.re_vorname;
          this.addressData.re_name1 = this.auftrag.re_name1;
          this.addressData.re_str_hnr = this.auftrag.re_str_hnr;
          this.addressData.re_land = this.auftrag.re_land;
          this.addressData.re_plz = this.auftrag.re_plz;
          this.addressData.re_ort = this.auftrag.re_ort;
        }
      } else if (this.einzel && this.einzel.id !== '') {
        this.addressData.gi_anrede = this.einzel.salutation;
        this.addressData.gi_name1 = this.einzel.name_1;
        this.addressData.gi_name2 = this.einzel.name_2;
        this.addressData.gi_strasse = this.einzel.street;
        this.addressData.gi_plz = this.einzel.zip_code;
        this.addressData.gi_ort = this.einzel.city;
        this.addressData.re_anrede = this.einzel.re_anrede;
        this.addressData.renr = this.einzel.re_nr;
        this.addressData.re_vorname = this.einzel.re_vorname;
        this.addressData.re_name1 = this.einzel.re_name_1;
        this.addressData.re_str_hnr = this.einzel.re_strh_nr;
        this.addressData.re_land = this.einzel.re_land;
        this.addressData.re_plz = this.einzel.re_plz;
        this.addressData.re_ort = this.einzel.re_ort;
      }
      this.$refs.a_geber_dialog.showModal();
    },
    showAccept(acceptEinzel) {
      let addressData = {};
      if (this.auftrag.gi_name1 != null) {
        addressData.gi_anrede = this.auftrag.gi_anrede;
        addressData.gi_name1 = this.auftrag.gi_name1;
        addressData.gi_name2 = this.auftrag.gi_name2;
        addressData.gi_strasse = this.auftrag.gi_strasse;
        addressData.gi_plz = this.auftrag.gi_plz;
        addressData.gi_ort = this.auftrag.gi_ort;
        if (this.auftrag.re_vorname != null) {
          addressData.re_anrede = this.auftrag.re_anrede;
          addressData.renr = this.auftrag.re_nr;
          addressData.re_vorname = this.auftrag.re_vorname;
          addressData.re_name1 = this.auftrag.re_name1;
          addressData.re_str_hnr = this.auftrag.re_str_hnr;
          addressData.re_land = this.auftrag.re_land;
          addressData.re_plz = this.auftrag.re_plz;
          addressData.re_ort = this.auftrag.re_ort;
        } else {
          addressData.re_anrede = '';
          addressData.renr = '';
          addressData.re_vorname = '';
          addressData.re_name1 = '';
          addressData.re_str_hnr = '';
          addressData.re_land = '';
          addressData.re_plz = '';
          addressData.re_ort = '';
        }
      } else if (this.einzel && this.einzel.id !== '') {
        addressData.gi_anrede = this.einzel.salutation;
        addressData.gi_name1 = this.einzel.name_1;
        addressData.gi_name2 = this.einzel.name_2;
        addressData.gi_strasse = this.einzel.street;
        addressData.gi_plz = this.einzel.zip_code;
        addressData.gi_ort = this.einzel.city;
        addressData.re_anrede = this.einzel.re_anrede;
        addressData.renr = this.einzel.re_nr;
        addressData.re_vorname = this.einzel.re_vorname;
        addressData.re_name1 = this.einzel.re_name_1;
        addressData.re_str_hnr = this.einzel.re_strh_nr;
        addressData.re_land = this.einzel.re_land;
        addressData.re_plz = this.einzel.re_plz;
        addressData.re_ort = this.einzel.re_ort;
      }
      this.$refs.accept_dialog.showDialog(addressData, acceptEinzel);
    },
    onOpenForwards(data) {
      this.showShare = false;
      this.forwards = data;
      if (this.forwards.length === 1) {
        this.forwardRoom = this.forwards[0];
      } else {
        this.$refs.forwards_dialog.showModal();
      }
    },
    onShared(room) {
      this.showShare = false;
      /*this.$bvToast.toast("Die Aufgabe wurde erfolgreich weitergeleitet.", {
        title: 'Weitergeleitet',
        autoHideDelay: 3000,
        appendToast: false,
        toaster: 'b-toaster-top-center',
      })*/
      this.forwards.unshift(room);
      this.$refs.task_forward_messaging.forwardRoom = room;
    },
    onShare() {
      this.showShare = true;
    },
    denyAnfrage() {
      this.showLoader();
      let payload ={
        deny_message: this.denyMessage,
        deny_message_plain: this.denyMessage,
      };
        this.showLoader();
        encryptMultipleAES(sessionStorage.getItem("aes"), [payload.deny_message]).then(res => {
          payload.deny_message = res[0];
          this.$http.post(
              Server_URL + '/auftragsbuch/data/deny/'+ this.auftrag.id, payload
          ).then(this.responseOkReload, this.responseError)
          this.showDeny = false;
        }).catch(res => {
        })
    },
    showDenyAufgabe() {
      if (this.auftrag.modul === 'mm') {
        this.denyMessage = this.denyMessageMmDefault;
      } else {
        this.denyMessage = "";
      }
      this.showDeny = true;
    },
    onAcceptTask(req) {
      this.showLoader();
      encryptMultipleAES(sessionStorage.getItem("aes"), [req.gi_memo, req.accept_note_plain]).then(res => {
        req.gi_memo = res[0];
        req.accept_note = res[1];
        if (this.hasDataId) {
          req.key = sessionStorage.getItem("aes");
        }
        if (req.todos && req.todos.length) {
          req.key = sessionStorage.getItem("aes");
          encryptTodos(sessionStorage.getItem("aes"), req.todos).then(res => {
            req.todos = res;
            this.$http.post(
                Server_URL+'/auftragsbuch/data/av/accept/' + this.auftrag.id,
                req,
            ).then(this.responseOkReload, this.responseError)
          }).catch(res => {
            console.log(res)
          })
        } else {
          this.$http.post(
              Server_URL+'/auftragsbuch/data/av/accept/' + this.auftrag.id,
              req,
          ).then(this.responseOkReload, this.responseError);
        }
      }).catch(res => {
        console.log(res);
      })
    },
    onNewPlanning(selected) {
      for (let i = 0; i < selected.length; i++) {
        let cur = selected[i];
        cur._id = v4();
        cur.memo = this.taskMemo;
        cur.dueDate = this.dueDate;
        this.selectedPlannings.push(cur);
      }
    },
    onLegrChanged(data) {
      this.$refs.accept_dialog.onSetLegr(data)
    },
    onAufisnChanged(data) {
      this.$refs.accept_dialog.onSetAufisn(data)
    },
    print() {
      this.$htmlToPaper('auftrag1', () => {
      });
    },
    onDelete() {
      this.delete_modal = true;
    },
    onDeleteOk() {
      this.delete_modal = false;
      this.showLoader();
      this.$http.delete(
          Server_URL + '/auftragsbuch/data/delete/' + this.auftrag.id
      ).then(this.onDeleteResponseOk, this.responseError)
    },
    onDeleteResponseOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.$router.go(-1);
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkFetch(response) {
      if (response.status === 200 && response.body.status === "ok") {
        this.userId = response.body.session.id;
        this.canShare = this.$cookies.get("ps_customer_number") === "8888810" || this.$cookies.get("ps_customer_number") === "7678986"
        let data = response.body.data;
        if (sessionStorage.getItem("aes") !== null) {
          this.decryptData(data.data.gi_memo, data.data.notiz_annahme, data.data.notiz_fertig, data.data.art).then(res => {
            data.data.gi_memo = res[0];
            data.data.notiz_annahme = res[1];
            data.data.notiz_fertig = res[2];
            this.setData(data);
          }).catch(e => {
            this.setData(data);
          });
        } else {
          this.setData(data);
        }
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    async decryptData(memo, annahme, fertig, art) {
      try {
        if (memo !== null && memo !== "") {
          memo = await decryptAES(sessionStorage.getItem("aes"), memo);
        }
      } catch (e) {
      }
      try {
        if (annahme !== null && annahme !== "" && art === "DE") {
          annahme = await decryptAES(sessionStorage.getItem("aes"), annahme);
        }
      } catch (e) {
      }
      try {
        if (fertig !== null && fertig !== "") {
          fertig = await decryptAES(sessionStorage.getItem("aes"), fertig);
        }
      } catch (e) {
      }
      return [memo, annahme, fertig]
    },
    setData(data) {
      this.auftrag = data.data;
      this.augrName = data.augr_name;
      this.allGroups = data.all_groups;
      this.bauhofStructure = data.bauhof_structure;
      this.forwards = data.forwarded_rooms;
      this.einzel = data.einzel;
      this.hideLoader();
      this.contact = "";
      if (this.auftrag.modul === "mm") {
        let defectData = JSON.parse(this.auftrag.custom_properties);
        let hasContact = defectData.name !== "" || defectData.email !== "" || defectData.phone_number !== "";
        if (hasContact) {
          if (defectData.name !== "") {
            this.contact += "Name: " + defectData.name + "\n"
          }
          if (defectData.email !== "") {
            this.contact += "Email: " + defectData.email + "\n"
          }
          if (defectData.phone_number !== "") {
            this.contact += "Tel: " + defectData.phone_number + "\n"
          }
        }
      }
      this.av_close_defaults = data.av_close_defaults;
      this.hasContact = this.contact !== "";
      this.editMode = false;
      this.canFinish = true;

      if (this.auftrag.art === "DE") {
        this.canFinish = false;
        this.disableChat = true;
        this.deleteMessage = this.auftrag.notiz_annahme;
        this.messagePlaceholder = "Der Auftrag ist abgelehnt."
      }
      if (this.auftrag.offen >= 1) {
        this.canFinish = false;
        this.disableChat = true;
        this.messagePlaceholder = "Der Auftrag ist abgeschlossen."
      }
      if (this.auftrag.notiz_fertig !== null && this.auftrag.notiz_fertig !== "") {
        this.fertigMessage = this.auftrag.notiz_fertig;
      }
      if (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "") {
        this.annahmeMessage = this.auftrag.notiz_annahme;
      }
      let res = JSON.parse(sessionStorage.getItem(this.auftrag.auftraggeber));
      if (res !== null) {
        this.auftrag.auftraggeber = res.username;
      }
      if (this.auftrag.auftraggeber in this.allGroups) {
        this.auftrag.auftraggeber = this.allGroups[this.auftrag.auftraggeber];
      }
      let res2 = JSON.parse(sessionStorage.getItem(this.auftrag.a_nehmer));
      if (res2 !== null) {
        this.auftrag.a_nehmer = res2.username;
      }
      if (this.auftrag.a_nehmer in this.allGroups) {
        this.auftrag.a_nehmer = this.allGroups[this.auftrag.a_nehmer];
      }

      if (this.auftrag.modul === "bk") {
        this.auftrag.auftraggeber = "Baumkontrolle";
      } else if (this.auftrag.modul === "k1") {
        this.auftrag.auftraggeber = "Spielplatzkontrolle";
      } else if (this.auftrag.modul === "k2" || this.auftrag.modul === "k4") {
        this.auftrag.auftraggeber = "GPS-Nachweis";
      } else if (this.auftrag.modul === "k3") {
        this.auftrag.auftraggeber = "Straßenkontrolle";
      } else if (this.auftrag.modul === "k5") {
        this.auftrag.auftraggeber = "Fast-Task";
      } else if (this.auftrag.modul === "mm") {
        this.auftrag.auftraggeber = "Mängelmelder";
        this.auftrag.sachbearbeiter = "Mängelmelder";
        this.auftrag.email = "Bauhof";
      }
      this.taskShort.id = this.auftrag.id;
      this.taskShort.from =this.auftrag.auftraggeber;
      this.taskShort.title =this.auftrag.gi_auf_ext;
      this.taskShort.description =this.auftrag.gi_memo;
      this.taskShort.where =this.auftrag.gi_match;
      this.taskShort.till =this.formateDate;

      res = JSON.parse(sessionStorage.getItem(this.auftrag.sachbearbeiter));
      if (res !== null) {
        this.auftrag.sachbearbeiter = res.first_name + " " + res.surname;
        this.auftrag.email = res.email;
      }
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
      this.attachments = data.attachments;
      this.bills = data.rechnungen;
      this.deletable = data.settings.use_delete;
      if (data.settings.fg_stufe1 && this.auftrag.art === "FG" && this.auftrag.freigabe1 === "-") {
        this.freigabe = data.user_settings.do_freigabe || this.auftrag.freigeber === data.user_settings.login;
      }
      this.hasChat = data.has_chat && this.auftrag.art !== "SO";
      if (this.hasChat && data.chat_room.roomId !== "") {
        data.chat_room.unreadCount = 0;
        this.$set(this.rooms, data.chat_room.roomId,
            {
          room: data.chat_room,
          showChatGroup: false,
          showChat: false,
          showInvite: false,
          lastOnline: null,
        })
        this.listeners[data.chat_room.roomId] = [];
        //this.room = data.chat_room;
        if (this.rooms[data.chat_room.roomId].room.is_active
            && !this.rooms[data.chat_room.roomId].room.is_archived) {
          let found = false;
          for (let i = 0; i < this.rooms[data.chat_room.roomId].room.users.length; i++) {
            if (this.rooms[data.chat_room.roomId].room.users[i]._id === this.userId) {
              found = true;
              break;
            }
          }
          if (found) {
            this.startListener(data.chat_room.roomId, this.$cookies.get("ps_user_id"));
          }
          if (this.$route.query.open_chat === "task") {
            this.showChat = data.chat_room.roomId;
          }
        }
      }
      if (this.hasChat && data.chat_room_internal.roomId !== "") {
        data.chat_room_internal.unreadCount = 0;
        this.$set(this.rooms, data.chat_room_internal.roomId,
            {
          room: data.chat_room_internal,
          showChatGroup: false,
          showChat: false,
          showInvite: false,
          lastOnline: null,
        })
        this.listeners[data.chat_room_internal.roomId] = [];
        //this.room = data.chat_room;
        if (this.rooms[data.chat_room_internal.roomId].room.is_active
            && !this.rooms[data.chat_room_internal.roomId].room.is_archived) {
          let found = false;
          for (let i = 0; i < this.rooms[data.chat_room_internal.roomId].room.users.length; i++) {
            if (this.rooms[data.chat_room_internal.roomId].room.users[i]._id === this.userId) {
              found = true;
              break;
            }
          }
          if (found) {
            this.startListener(data.chat_room_internal.roomId, this.$cookies.get("ps_user_id"));
          }
          if (this.$route.query.open_chat === "int") {
            this.showChat = data.chat_room_internal.roomId;
          }
        }
      }
    },
    addRoomUser(roomId, u) {
      let found = false;
      for (let i = 0; i < this.rooms[roomId].room.users.length; i++) {
        if (this.rooms[roomId].room.users[i]._id === u) {
          found = true;
          break;
        }
      }
      if (!found) {
        this.rooms[roomId].room.users.push({_id: u,  username: ""})
        if (this.userId === u) {
          this.startListener(roomId, u)
        }
      }
    },
    leaveRoom(roomId) {
      for (let i = 0; i < this.rooms[roomId].room.users.length; i++) {
        if (this.rooms[roomId].room.users[i]._id === this.userId) {
          this.rooms[roomId].room.users.splice(i, 1);
          break;
        }
      }
      this.listeners[roomId].forEach(listener => listener());
      this.listeners[roomId] = [];
    },
    startListener(roomId, userId) {
      if (userId === this.$cookies.get("ps_user_id")) {
        if (this.listeners[roomId]) {
          this.listeners[roomId].forEach(listener => listener());
        }
        this.listeners[roomId] = [];
        const unsub = listenMessageCounter(this.$cookies.get("ps_customer_number"),
            this.rooms[roomId].room.roomId,
            this.$cookies.get("ps_user_id"),
            (data) => {
              this.rooms[roomId].room.unreadCount = data.count_unread;
              this.rooms[roomId].lastOnline = data.last_active.toDate();
            });
        this.listeners[roomId].push(unsub)
      }
    },

    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    back() {
      window.history.back();
    },
    responseErrorTrap(response) {
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        console.log(response);
      }
    },
    responseOkReload() {
      this.hideLoader();
      this.$router.go();
    },
    showMapIfNeeded() {

      if (this.map !== undefined || this.auftrag.lat === 0.0 || this.auftrag.lon === 0.0) {
        return;
      }

      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        center: [this.auftrag.lon, this.auftrag.lat],
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.map.addControl(new ZoomControl(), 'bottom-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

      this.marker = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    mapLoad() {
      setTimeout(() => {
        if (this.marker === null) {
          let el = document.createElement('div');
          el.className = 'marker';

          this.marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.auftrag.lon, this.auftrag.lat])
              .addTo(this.map);
        }
        this.map.resize();
        this.hideLoader()
      });
    },
  }
}
</script>

<style>

.marker {
  background-image: url('../../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.sc-message {
  width: 480px;
}

.sc-message--text .sc-message--toolbox {
  display: none;
}

.sc-launcher.opened :before {
  box-shadow: none;
}

.sc-launcher.opened:before {
  box-shadow: none !important;
}

.sc-chat-window {
  border: 1px solid lightgray !important;
  width: 520px !important;
  z-index: 5;
}

.sc-launcher {
  z-index: 5;
}

.sc-header {
  min-height: unset !important;
}

.sc-user-input {
  border-top: 1px solid lightgray !important;

}

.sc-user-input--text {
  width: 450px !important;
}

.sc-header--close-button {
  margin-left: 0 !important;
}

.my-body {
  padding: 0 !important;
}

.hidden_header {
  display: none;
}

.sc-user-input--file-icon-wrapper {
  margin-bottom: 0;
}
</style>

<style scoped>

.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.p-center {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0;
}

.bold-text {
  font-weight: bold;
}

::placeholder { /* Firefox, Chrome, Opera */
  color: black;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}

</style>
